<template>
  <div class="operationProcess">
    <div @click="see">
      <img
        style="width:100%;"
        :src="src"
      >
    </div>
    <div
      class="ps"
      @click="see"
    >点击可放大查看图片</div>
    <div
      class="btn"
      @click="goIndex"
    >进入检测中心</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productTypeId: "",
      src: "",
    };
  },
  created() {
    // 1594629496721用户操作流程妇产科
    let query = this.$route.query;
    if (query.doctorId && query.doctorId != "1263309689931636737")
      localStorage.setItem("doctorId", query.doctorId);
    if (query.productTypeId && query.productTypeId != 0)
      localStorage.setItem("productTypeId", query.productTypeId);
    // if (localStorage.getItem("productTypeId") == "1280700923675324417")
    //   this.src = "https://m.ibnsina360.com/1594629496721用户操作流程妇产科.png";
    // else if (localStorage.getItem("productTypeId") == "1280694927049535489")
    //   this.src = "https://m.ibnsina360.com/1594629496721用户操作流程神经科.png";
    // else if (localStorage.getItem("productTypeId") == "1282561044701425666")
    //   this.src =
    //     "https://m.ibnsina360.com/1594629496721用户操作流程神经科中山三院.png";
    this.getFlowChart();
    if (!this.$store.state.wxConfigFlag) this.$wxConfig();
  },
  methods: {
    see() {
      this.wx.previewImage({
        current: this.src, // 当前显示图片的http链接
        urls: [this.src], // 需要预览的图片http链接列表
      });
    },
    goIndex() {
      this.$router.push({
        name: "Index",
        query: {
          doctorId: localStorage.getItem("doctorId"),
          productTypeId: localStorage.getItem("productTypeId"),
        },
      });
    },
    getFlowChart(id) {
      return new Promise((success, error) => {
        this.$http
          .get(
            `/product-type/baseControllerGetById/${localStorage.getItem(
              "productTypeId"
            )}`
          )
          .then((res) => {
            if (res.data.code == 200) {
              let data = res.data.data;
              if (data) this.src = data.flowChart;
            }
            success();
          })
          .catch((err) => {
            error();
          });
      });
    },
  },
};
</script>

<style lang='less' scoped>
.ps {
  text-align: center;
  font-size: 26px;
  color: #999;
  line-height: 50px;
}
.btn {
  width: 300px;
  height: 80px;
  line-height: 80px;
  border-radius: 80px;
  margin: 30px auto;
  text-align: center;
  background-color: #1968a8;
  color: #fff;
  font-size: 34px;
}
</style>
